export const conf = {
    server: process.env.REACT_APP_API_URL,
    stats: process.env.REACT_APP_STATS_API_URL,
    topAccounts: process.env.REACT_APP_ACCOUNTS_API_URL,
    LIVENET: process.env.REACT_APP_LIVENET,
    livenetUrl : process.env.REACT_APP_LIVENET_URL,
    testnetUrl : process.env.REACT_APP_TESTNET_URL,
    circulatingSupplyUrl: process.env.CIRCULATING_SUPPLY_URL,
    port: 3000
}
  



// WEBPACK FOOTER //
// ./src/conf2.js